module.exports = __webpack_public_path__ + "img/btnClicked.4c0aa3d8.png";